const FPS_60 = 1_000 / 60;

/** Debounces the specified function.
 * @param {(...args)=>void} fn - The function that should be debounced
 * @param {[object]} options - The options
 * @param {number} options.ms - The throttle duration. Defaults to 60 fps.
 * @param {boolean} options.leading - By default, the call that begins the debounce window does not execute. Enable
 * `leading` to invoke the first function immediately. When `leading` is enabled a single call to the debounced function
 * will result in two function calls.
 */
export default (fn, { ms = FPS_60, leading = false } = {}) => {
  let timeout = 0;
  return (...args) => {
    if (leading && !timeout) {
      fn(...args);
    }

    clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = 0;
      fn(...args);
    }, ms);
  };
};
